import { render } from "./CollectionDetail.vue?vue&type=template&id=106eec37&scoped=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=js"
export * from "./CollectionDetail.vue?vue&type=script&lang=js"

import "./CollectionDetail.vue?vue&type=style&index=0&id=106eec37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106eec37"]])

export default __exports__